export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-13.905b4857.jpg";